<template>
  <div class="col-span-12 xl:col-span-4"><slot /></div>
</template>
